module.exports = __webpack_public_path__ + "img/Namtaopupa.0793d50c.jpg";